import { t } from 'i18next'


// we don't put this into an ENUM because we want to keep is as a string
export const travelCard = [ 
    {label: t<string>('person.public_transport.half_fare'), value: t<string>('person.public_transport.half_fare')},
    {label: t<string>('person.public_transport.second_ga'), value:  t<string>('person.public_transport.second_ga')},
    {label: t<string>('person.public_transport.first_ga'), value: t<string>('person.public_transport.first_ga')},
  ]
